import axiosInstance from "./axiosInstance";

const authApi = {
  createAccount: (data) =>
    axiosInstance.post("/auth/create-account", data),

  login: (data) =>
    axiosInstance.post("/auth/login", data),

  verifyOtp: (data) =>
    axiosInstance.post("/auth/verify-otp", data),
};

export default authApi;
